module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/VN-bf7a716fe0b07fbae450e5d50a01a7b3.png";